import { useEffect, useState } from 'react';
import { operatorConsole, type OperatorMe, type OperatorSession } from '../../lib/api/operatorConsole';
import { OperatorInfoCard } from './OperatorInfoCard';
import { RecentSessionsCard } from './RecentSessionsCard';

export function DashboardPage() {
  const [me, setMe] = useState<OperatorMe | null>(null);
  const [sessions, setSessions] = useState<OperatorSession[]>([]);
  const [error, setError] = useState<string | null>(null);

  const [maySeeSessions, setMaySeeSessions] = useState(true);

  useEffect(() => {
    let cancelled = false;
    // Sessions are asked for only after /me says this console user may see
    // them: fetching both at once would let one 403 take the whole dashboard
    // down for a team member who simply lacks that section.
    void operatorConsole
      .me()
      .then(async (meRes) => {
        if (cancelled) return;
        setMe(meRes);

        const permissions = meRes.owner.permissions;
        const allowed = permissions === undefined || permissions.includes('players');
        setMaySeeSessions(allowed);
        if (!allowed) return;

        const sessionsRes = await operatorConsole.listSessions({ per: 5 });
        if (!cancelled) setSessions(sessionsRes?.sessions ?? []);
      })
      .catch((e: unknown) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load dashboard');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex flex-col gap-6 p-6">
      <h1 className="text-[24px] font-bold text-[var(--ui-text-primary,#15181E)]">Dashboard</h1>
      {error && (
        <div role="alert" className="rounded-md bg-[var(--ui-bg-card,#F2F2F2)] p-3 text-[13px] text-[var(--ui-text-primary,#15181E)]">
          {error}
        </div>
      )}
      {me && (
        <>
          <OperatorInfoCard operator={me.operator} owner={me.owner} />
          {maySeeSessions && <RecentSessionsCard sessions={sessions} />}
        </>
      )}
    </div>
  );
}
